import { api } from "./api";
import type { User } from "@/types/models";

interface CreateUserPayload {
  phone: string;
  name: string;
  pin: string;
  role: string;
  email?: string;
}

interface UpdateUserPayload {
  phone: string;
  name: string;
  role: string;
  active: boolean;
  email?: string;
}

export const userService = {
  list: () => api.get<User[]>("/users").then((r) => r.data),
  get: (id: number) => api.get<User>(`/users/${id}`).then((r) => r.data),
  create: (data: CreateUserPayload) =>
    api.post<User>("/users", data).then((r) => r.data),
  update: (id: number, data: UpdateUserPayload) =>
    api.put<User>(`/users/${id}`, data).then((r) => r.data),
  deactivate: (id: number) => api.delete(`/users/${id}`),
  resetPIN: (id: number, pin: string) =>
    api.post(`/users/${id}/reset-pin`, { pin }),
};
